import type { Tournament } from '@chess-uno/shared-protocol'
import { SERVER_URL, type StoredSession } from './session.js'

async function get<T>(path: string, session?: StoredSession | null): Promise<T | null> {
  const res = await fetch(`${SERVER_URL}${path}`, { headers: session ? { authorization: `Bearer ${session.token}` } : {} }).catch(() => null)
  if (!res?.ok) return null
  return (await res.json()) as T
}

/** Public: a tournament can be looked at with its code alone. */
export function fetchTournament(code: string): Promise<Tournament | null> {
  return get<Tournament>(`/api/tournaments/${encodeURIComponent(code)}`)
}

/** Tournaments the player takes part in or runs, not over yet. */
export async function fetchMyTournaments(session: StoredSession): Promise<Tournament[]> {
  return (await get<{ tournaments: Tournament[] }>('/api/me/tournaments', session))?.tournaments ?? []
}

let idleMinutes: Promise<number> | null = null

/** Minutes of inactivity after which a tournament player forfeits (server setting, read once). */
export function fetchIdleMinutes(): Promise<number> {
  idleMinutes ??= get<{ tournamentIdleMs?: number }>('/api/rules').then((r) => Math.max(1, Math.round((r?.tournamentIdleMs ?? 180_000) / 60_000)))
  return idleMinutes
}
